/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable camelcase */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getBetInfo = (obj: any, toFix: number, currency: string) => {
  const { bet, mult, win } = obj

  // let num = win?.toString()
  // num = num?.includes(".") ? num?.slice(0, num.indexOf(".") + 3) : num

  const BET_INFO = [
    {
      title: "Bet",
      content: bet && (+bet).toFixed(toFix) + " " + currency,
    },
    {
      title: "Payout",
      content: mult === 0 ? "0.00 X" : (+mult).toFixed(2) + " X",
    },
    {
      title: "Win",
      content:
        Number(win) > 0
          ? (+win).toFixed(toFix) + " " + currency
          : "0.00 " + currency,
    },
  ]
  return { BET_INFO }
}

export default getBetInfo
